import { IConfig } from '@cian/config/shared';

// TODO: Удалить фича-флаг в CD-203170.
export const getNewbuildingPromosSeoEnabled = (config: IConfig): boolean => {
  return config.get<boolean>('newbuildingPromos.seo.Enabled') || false;
};
